import { render, staticRenderFns } from "./OverPriceForm.vue?vue&type=template&id=a4e0774e"
import script from "./OverPriceForm.vue?vue&type=script&lang=js"
export * from "./OverPriceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports